<template>
  <div class="page-container has-action">
    <van-nav-bar class="buying-navbar" :title="product.name" fixed left-arrow @click-left="goableBack()" />

    <div class="buying">
      <div class="block">
        <div class="fs-16">买入金额</div>
        <template v-if="product.mustAmount">
          <van-field class="tian-amount mt-10" type="number" v-model="payForm.tradeAmount" @blur="setAmountInMin" @input="onInput" readonly>
            <div slot="left-icon">￥</div>
          </van-field>
        </template>
        <template v-else>
          <van-field class="tian-amount mt-10" type="number" v-model="payForm.tradeAmount" @blur="setAmountInMin" @input="onInput" :placeholder="getMiniAmount(product.miniAmount)" readonly>
            <div slot="left-icon">￥</div>
          </van-field>
        </template>
        <template>
          <div class="mt-20 fs-14" @click="automatic = false">
            {{ fundOutTypeRadio[payForm.fundOutType] }}
            <!-- <van-icon
              class="ml-5 fs-16"
              name="arrow-down"
              style="vertical-align: middle" /> -->
          </div>
        </template>
      </div>
      <div class="block mt-5">
        <div class="fs-16">支付方式</div>
        <van-radio-group disabled class="mt-10" v-model="payForm.pattern_buying" @change="patternBuyingChange">
          <!-- <van-cell v-if="payControl.payType.includes('2')" class="px-0">
            <van-radio slot="title" name="2" checked-color="#c7a673">
              <div class="fs-14">在线支付</div>
            </van-radio>
            <div class="fs-14 color-gray-dark" @click="bankCeiling.show = true">
              查看限额
            </div>
          </van-cell>
          <transition name="van-fade">
            <van-cell v-if="payForm.pattern_buying == 2 && userInfo.isBindCard" class="pr-0 pl-30 bank-card-selector">
              <van-field v-model="chooseCard" readonly clearable input-align="right" label="银行卡" placeholder="请选择银行卡" @click="bankPicker.show = true" right-icon="arrow-down" />
            </van-cell>
          </transition> -->

          <van-cell v-if="payControl.payType.includes('3')" class="px-0">
            <van-radio slot="title" name="3" checked-color="#c7a673">
              <div>
                <div class="fs-14" style="line-height: 0.6rem">余额</div>
                <div class="color-gray-dark" style="line-height: 0.6rem">
                  目前可用余额{{ balance | numFormat }}元
                </div>
              </div>
            </van-radio>
          </van-cell>
        </van-radio-group>
      </div>
      <div v-if="selfChannel" class="block mt-5 coupon">
        <div class="fs-16 pb-15">红包选择</div>
        <van-cell @click="onClickCashCouponCell" center class="fs-14" title="体验金券" label="输入买入金额后查看可用的体验金券">
          <template #right-icon>
            <span class="fs-14" v-if="payForm && !payForm.cashCouponAmount">
              <span v-if="cashCouponTips.indexOf('可用') > 0" class="tips-color">
                {{ cashCouponTips }}
              </span>
              <span v-else>
                {{ cashCouponTips }}
              </span>
            </span>
            <span v-else style="color: red">
              -{{ payForm.cashCouponAmount }}
            </span>
            <van-icon name="arrow" />
          </template>
        </van-cell>
        <van-cell center title="加息券" label="输入买入金额后查看可用的加息券" class="fs-14 mt-15" @click="onClickRateCouponCell">
          <template #right-icon>
            <span class="fs-14" v-if="payForm && !payForm.rateCouponAmount">
              <span v-if="rateCouponTips.indexOf('可用') > 0" class="tips-color">
                {{ rateCouponTips }}
              </span>
              <span v-else>
                {{ rateCouponTips }}
              </span>
            </span>
            <span v-else style="color: red">+{{ payForm.rateCouponAmount }}%</span>
            <van-icon name="arrow" />
          </template>
        </van-cell>
        <van-cell v-if="decreCashCouponList.data.length > 0" center title="满减券" label="输入买入金额后查看可用的满减券" class="fs-14 mt-15" @click="onClickDecreCashCouponCell">
          <template #right-icon>
            <span class="fs-14" v-if="payForm && !payForm.decreCashCouponAmount">
              <span v-if="decreCashCouponTips.indexOf('可用') > 0" class="tips-color">
                {{ decreCashCouponTips }}
              </span>
              <span v-else>
                {{ decreCashCouponTips }}
              </span>
            </span>
            <span v-else style="color: red">-{{ payForm.decreCashCouponAmount }}</span>
            <van-icon name="arrow" />
          </template>
        </van-cell>
      </div>
    </div>

    <div class="page-action block mt-5">
      <van-cell center v-show="showNextStep" :border="false" class="protcol_agree_box">
        <template #title>
          <span class="fs-14" style="margin-right: 10px">
            <span>同意</span>
            <span class="tips-color" @click.stop="protocolList.show = protocolList.data.length">
              体验
            </span>
          </span>
          <van-icon v-if="protocolList.data.length > 0" @click.stop="protocolList.show = true" name="arrow-up" />
        </template>
        <template #right-icon>
          <van-switch v-model="payForm.agreement_buying" active-color="#c7a673" inactive-color="#dcdee0" size="20" />
        </template>
      </van-cell>
      <van-cell v-if="product.purchaseActivity" :border="false" class="activity_box">
        <template #title>
          <span class="fs-14" style="margin-right: 10px">
            <span>每满<span class="tips-amount-color">{{
                product.activityDiscount.amount / 100
              }}</span>元减<span class="tips-amount-color">{{
                product.activityDiscount.discount / 100
              }}</span>元</span>
            <span>
              ，本次满减金额<span class="tips-amount-color">
                {{ payForm.discount / 100 }} </span>元。
            </span>
          </span>
        </template>
      </van-cell>
      <van-cell v-if="product.hasNewYearActivity && product.activityDiscount" :border="false" class="activity_box">
        <template #title>
          <span class="fs-14" style="margin-right: 10px">
            <span>
              <span class="tips-amount-color"> {{ product.attachLabel }} </span>
            </span>
          </span>
        </template>
      </van-cell>
      <van-row type="flex">
        <van-col :span="showNextStep ? 18 : nextStepErrorTips.length > 10 ? 8 : 14">
          <div class="page_action_left">
            <span class="color-red">
              <span>¥</span>
              <span class="fs-20">
                {{ numFormat(payForm.payAmount * 100) }}
              </span>
            </span>
            <span class="fs-10" style="color: gray; word-spacing: 2px">
              <span v-show="
                  payForm &&
                  (payForm.cashCouponAmount || payForm.decreCashCouponAmount)
                ">
                <span>抵扣:</span>
                <!-- payForm.cashCouponAmount + payForm.decreCashCouponAmount -->
                <span class="color-red">
                  ¥{{
                    _addDecimal(
                      payForm.cashCouponAmount,
                      payForm.decreCashCouponAmount
                    )
                  }}</span>
              </span>
              <span v-show="payForm && payForm.rateCouponAmount">
                <span> 加息:</span>
                <span class="color-red"> {{ payForm.rateCouponAmount }}% </span>
              </span>
              <span>
                <span> 预期收益:</span>
                <span class="color-red"> ¥{{ numFormat(returnAmount) }} </span>
              </span>
            </span>
          </div>
        </van-col>
        <van-col :span="showNextStep ? 6 : nextStepErrorTips.length > 10 ? 16 : 10">
          <van-row type="flex" justify="end" align="center" class="page_action_right">
            <van-button class="next_step" v-if="showNextStep" @click="onClickNext">
              下一步
            </van-button>
            <van-button class="next_step" disabled v-else>
              {{ this.nextStepErrorTips }}
            </van-button>
          </van-row>
        </van-col>
      </van-row>
    </div>

    <!-- 加息券弹窗 -->
    <van-popup ref="rateCouponPopup" v-model="showRateCouponPopup" class="cash-coupon-list" closeable @open="openRateCouponPopup" @close="comfirmCheckedRateCoupon" close-icon="close" close-icon-position="top-right" position="bottom" round>
      <van-tabs v-model="rateCouponActiveName">
        <van-tab :title="'可用加息券(' + this.rateCouponList.available.length + ')'" name="available">
          <div class="cash-coupon-panel">
            <van-checkbox-group @change="checkedRateCouponChanged" v-model="rateCouponList.checked">
              <div class="coupon-cell-container" v-for="item in rateCouponList.available" :key="item.id">
                <div class="coupon_checkbox">
                  <van-checkbox :disabled="item.disabled" :name="item.id" checked-color="#c7a673">
                  </van-checkbox>
                </div>
                <van-cell>
                  <template #title>
                    <div class="coupon_item_container">
                      <van-row type="flex">
                        <van-col span="9">
                          <div class="coupon_item_left">
                            <span>
                              <span> {{ item.amount }} </span>
                              <span>%</span>
                            </span>
                            <span style="font-size: 10px">
                              满{{ item.condStartAmt }}元可用
                            </span>
                          </div>
                        </van-col>
                        <van-col span="1">
                          <div class="coupon_border" />
                        </van-col>
                        <van-col span="14">
                          <div class="coupon_item_right">
                            <span class="fs-12"> {{ item.name }} </span>
                            <br />
                            <span class="fs-10">
                              {{ dateSplit(item.takeEffectTime) }}
                              <span> 至 </span>
                              {{ dateSplit(item.expiryTime) }}
                            </span>
                            <br />
                            <span class="if-any-superposition" v-if="item.ifSuperposition == 2">
                              任意叠加
                            </span>
                            <span class="if-superposition" v-else-if="item.ifSuperposition == 1">
                              可叠加
                            </span>
                            <span class="if-no-superposition" v-else>
                              不可叠加
                            </span>
                            <template v-if="item.label && item.label > 0">
                              <div class="label-bg">
                                <span class="if_label">{{
                                  item.lableString
                                }}</span>
                              </div>
                            </template>
                          </div>
                        </van-col>
                      </van-row>
                    </div>
                  </template>
                </van-cell>
              </div>
            </van-checkbox-group>
          </div>
          <div class="fixed-popup-bottom">
            <div style="margin-bottom: 5px">
              <span @click="showRateCouponUseRules = true">使用规则</span>
              <van-icon name="question"></van-icon>
            </div>
            <van-button @click="comfirmCheckedRateCoupon" round type="danger">
              确 定
            </van-button>
          </div>
        </van-tab>
        <van-tab :title="
            '不可用加息券(' + this.rateCouponList.inavailable.length + ')'
          " name="inavailable">
          <div class="cash-coupon-panel">
            <div class="coupon-cell-container" v-for="item in rateCouponList.inavailable" :key="item.id">
              <van-cell>
                <template #title>
                  <div class="coupon_item_container">
                    <van-row type="flex">
                      <van-col span="9">
                        <div class="coupon_item_left">
                          <span>
                            <span> {{ item.amount }} </span>
                            <span>%</span>
                          </span>
                          <span style="font-size: 10px">
                            满 {{ item.condStartAmt }} 元可使用
                          </span>
                        </div>
                      </van-col>
                      <van-col span="1">
                        <div class="coupon_border" />
                      </van-col>
                      <van-col span="14">
                        <div class="coupon_item_right">
                          <span class="fs-12"> {{ item.name }} </span>
                          <br />
                          <span class="fs-10">
                            {{ dateSplit(item.takeEffectTime) }}
                            <span> 至 </span>
                            {{ dateSplit(item.expiryTime) }}
                          </span>
                          <br />
                          <span class="if-any-superposition" v-if="item.ifSuperposition == 2">
                            任意叠加
                          </span>
                          <span class="if-superposition" v-else-if="item.ifSuperposition == 1">
                            可叠加
                          </span>
                          <span class="if-no-superposition" v-else>
                            不可叠加
                          </span>
                          <template v-if="item.label && item.label > 0">
                            <div class="label-bg">
                              <span class="if_label">{{
                                item.lableString
                              }}</span>
                            </div>
                          </template>
                        </div>
                      </van-col>
                    </van-row>
                  </div>
                </template>
              </van-cell>
            </div>
          </div>
          <div class="fixed-popup-bottom">
            <div style="margin-bottom: 5px">
              <span @click="showRateCouponUseRules = true">使用规则</span>
              <van-icon name="question"></van-icon>
            </div>
          </div>
        </van-tab>
      </van-tabs>
    </van-popup>

    <!-- 体验金券弹窗 -->
    <van-popup ref="couponPopup" v-model="showCashCouponPopup" class="cash-coupon-list" closeable @open="openCashCouponPopup" @close="comfirmCheckedCashCoupon" close-icon="close" close-icon-position="top-right" position="bottom" round>
      <van-tabs v-model="cashCouponActiveName">
        <van-tab :title="'可用体验金券(' + this.cashCouponList.available.length + ')'" name="available">
          <div class="cash-coupon-panel">
            <van-checkbox-group @change="checkedCashCouponChanged" v-model="cashCouponList.checked">
              <div class="coupon-cell-container" v-for="item in cashCouponList.available" :key="item.id">
                <div class="coupon_checkbox">
                  <van-checkbox :disabled="item.disabled" :name="item.id" checked-color="#c7a673">
                  </van-checkbox>
                </div>
                <van-cell>
                  <template #title>
                    <div class="coupon_item_container">
                      <van-row type="flex">
                        <van-col span="9">
                          <div class="coupon_item_left">
                            <span>
                              <em>¥</em>
                              <span> {{ item.amount }} </span>
                            </span>
                            <span style="font-size: 10px">
                              满{{ item.condStartAmt }}元可用
                            </span>
                          </div>
                        </van-col>
                        <van-col span="1">
                          <div class="coupon_border" />
                        </van-col>
                        <van-col span="14">
                          <div class="coupon_item_right">
                            <span class="fs-12"> {{ item.name }} </span>
                            <br />
                            <span style="font-size: 10px">
                              {{ dateSplit(item.takeEffectTime) }}
                              <span> 至 </span>
                              {{ dateSplit(item.expiryTime) }}
                            </span>
                            <br />
                            <span class="if-any-superposition" v-if="item.ifSuperposition == 2">
                              任意叠加
                            </span>
                            <span class="if-superposition" v-else-if="item.ifSuperposition == 1">
                              可叠加
                            </span>
                            <span class="if-no-superposition" v-else>
                              不可叠加
                            </span>
                            <template v-if="item.label && item.label > 0">
                              <div class="label-bg">
                                <span class="if_label">{{
                                  item.lableString
                                }}</span>
                              </div>
                            </template>
                          </div>
                        </van-col>
                      </van-row>
                    </div>
                  </template>
                </van-cell>
              </div>
            </van-checkbox-group>
          </div>
          <div class="fixed-popup-bottom">
            <div style="margin-bottom: 5px">
              <span @click="showCashCouponUseRules = true">使用规则</span>
              <van-icon name="question"></van-icon>
            </div>
            <van-button @click="comfirmCheckedCashCoupon" round type="danger">
              确 定
            </van-button>
          </div>
        </van-tab>
        <van-tab :title="
            '不可用体验金券(' + this.cashCouponList.inavailable.length + ')'
          " name="inavailable">
          <div class="cash-coupon-panel">
            <div class="coupon-cell-container" v-for="item in cashCouponList.inavailable" :key="item.id">
              <van-cell>
                <template #title>
                  <div class="coupon_item_container">
                    <van-row type="flex">
                      <van-col span="9">
                        <div class="coupon_item_left">
                          <span>
                            <em>¥</em>
                            <span> {{ item.amount }} </span>
                          </span>
                          <span style="font-size: 10px">
                            满 {{ item.condStartAmt }} 元可使用
                          </span>
                        </div>
                      </van-col>
                      <van-col span="1">
                        <div class="coupon_border" />
                      </van-col>
                      <van-col span="14">
                        <div class="coupon_item_right">
                          <span class="fs-12"> {{ item.name }} </span>
                          <br />
                          <span style="font-size: 10px">
                            {{ dateSplit(item.takeEffectTime) }}
                            <span> 至 </span>
                            {{ dateSplit(item.expiryTime) }}
                          </span>
                          <br />
                          <span class="if-any-superposition" v-if="item.ifSuperposition == 2">
                            任意叠加
                          </span>
                          <span class="if-superposition" v-else-if="item.ifSuperposition == 1">
                            可叠加
                          </span>
                          <span class="if-no-superposition" v-else>
                            不可叠加
                          </span>
                          <template v-if="item.label && item.label > 0">
                            <div class="label-bg">
                              <span class="if_label">{{
                                item.lableString
                              }}</span>
                            </div>
                          </template>
                        </div>
                      </van-col>
                    </van-row>
                  </div>
                </template>
              </van-cell>
            </div>
          </div>
          <div class="fixed-popup-bottom">
            <div style="margin-bottom: 5px">
              <span @click="showCashCouponUseRules = true">使用规则</span>
              <van-icon name="question"></van-icon>
            </div>
          </div>
        </van-tab>
      </van-tabs>
    </van-popup>

    <!-- 满减券弹窗 -->
    <van-popup ref="couponPopup" v-model="showDecreCashCouponPopup" class="cash-coupon-list" closeable @open="openDecreCashCouponPopup" @close="comfirmCheckedDecreCashCoupon" close-icon="close" close-icon-position="top-right" position="bottom" round>
      <van-tabs v-model="decreCashCouponActiveName">
        <van-tab :title="
            '可用满减券(' + this.decreCashCouponList.available.length + ')'
          " name="available">
          <div class="cash-coupon-panel">
            <van-checkbox-group @change="checkedDecreCashCouponChanged" v-model="decreCashCouponList.checked">
              <div class="coupon-cell-container" v-for="item in decreCashCouponList.available" :key="item.id">
                <div class="coupon_checkbox">
                  <van-checkbox :disabled="item.disabled" :name="item.id" checked-color="#c7a673">
                  </van-checkbox>
                </div>
                <van-cell>
                  <template #title>
                    <div class="coupon_item_container">
                      <van-row type="flex">
                        <van-col span="9">
                          <div class="coupon_item_left">
                            <span>
                              <em>¥</em>
                              <span> {{ item.amount }} </span>
                            </span>
                            <span style="font-size: 10px">
                              满{{ item.condStartAmt }}元可用
                            </span>
                          </div>
                        </van-col>
                        <van-col span="1">
                          <div class="coupon_border" />
                        </van-col>
                        <van-col span="14">
                          <div class="coupon_item_right">
                            <span class="fs-12"> {{ item.name }} </span>
                            <br />
                            <span style="font-size: 10px">
                              {{ dateSplit(item.takeEffectTime) }}
                              <span> 至 </span>
                              {{ dateSplit(item.expiryTime) }}
                            </span>
                            <br />
                            <span class="if-any-superposition" v-if="item.ifSuperposition == 2">
                              任意叠加
                            </span>
                            <span class="if-superposition" v-else-if="item.ifSuperposition == 1">
                              可叠加
                            </span>
                            <span class="if-no-superposition" v-else>
                              不可叠加
                            </span>
                            <template v-if="item.label && item.label > 0">
                              <div class="label-bg">
                                <span class="if_label">{{
                                  item.lableString
                                }}</span>
                              </div>
                            </template>
                          </div>
                        </van-col>
                      </van-row>
                    </div>
                  </template>
                </van-cell>
              </div>
            </van-checkbox-group>
          </div>
          <div class="fixed-popup-bottom">
            <div style="margin-bottom: 5px">
              <span @click="showDecreCashCouponUseRules = true">使用规则</span>
              <van-icon name="question"></van-icon>
            </div>
            <van-button @click="comfirmCheckedDecreCashCoupon" round type="danger">
              确 定
            </van-button>
          </div>
        </van-tab>
        <van-tab :title="
            '不可用满减券(' + this.decreCashCouponList.inavailable.length + ')'
          " name="inavailable">
          <div class="cash-coupon-panel">
            <div class="coupon-cell-container" v-for="item in decreCashCouponList.inavailable" :key="item.id">
              <van-cell>
                <template #title>
                  <div class="coupon_item_container">
                    <van-row type="flex">
                      <van-col span="9">
                        <div class="coupon_item_left">
                          <span>
                            <em>¥</em>
                            <span> {{ item.amount }} </span>
                          </span>
                          <span style="font-size: 10px">
                            满 {{ item.condStartAmt }} 元可使用
                          </span>
                        </div>
                      </van-col>
                      <van-col span="1">
                        <div class="coupon_border" />
                      </van-col>
                      <van-col span="14">
                        <div class="coupon_item_right">
                          <span class="fs-12"> {{ item.name }} </span>
                          <br />
                          <span style="font-size: 10px">
                            {{ dateSplit(item.takeEffectTime) }}
                            <span> 至 </span>
                            {{ dateSplit(item.expiryTime) }}
                          </span>
                          <br />
                          <span class="if-any-superposition" v-if="item.ifSuperposition == 2">
                            任意叠加
                          </span>
                          <span class="if-superposition" v-else-if="item.ifSuperposition == 1">
                            可叠加
                          </span>
                          <span class="if-no-superposition" v-else>
                            不可叠加
                          </span>
                          <template v-if="item.label && item.label > 0">
                            <div class="label-bg">
                              <span class="if_label">{{
                                item.lableString
                              }}</span>
                            </div>
                          </template>
                        </div>
                      </van-col>
                    </van-row>
                  </div>
                </template>
              </van-cell>
            </div>
          </div>
          <div class="fixed-popup-bottom">
            <div style="margin-bottom: 5px">
              <span @click="showDecreCashCouponUseRules = true">使用规则</span>
              <van-icon name="question"></van-icon>
            </div>
          </div>
        </van-tab>
      </van-tabs>
    </van-popup>

    <!-- 限额列表 -->
    <van-popup class="limit-list" v-model="bankCeiling.show" closeable close-icon="close" close-icon-position="top-right" position="bottom" round>
      <div style="margin-top: 25px; margin-bottom: 5px">
        <van-cell v-for="(item, inde) in bankCeiling.columns" :key="inde">
          <van-cell :title="item.bankName" :value="item.quota" />
        </van-cell>
      </div>
    </van-popup>

    <!-- 协议弹窗 -->
    <van-popup v-model="protocolList.show" closeable position="bottom" close-icon-position="top-left">
      <div class="ta-c p-10" style="height: 50vh">
        <div class="fs-16">交易协议</div>
        <div class="ta-c pt-20 fs-16 color-gray-dark" v-for="(n, i) in protocolList.data" :key="'protocol_' + i" @click.stop="showProtocol(n.id)">
          {{ n.name }}
        </div>
        <!-- <div v-if="protocolList.data.length<3"
            class="ta-c pt-20 fs-16 color-gray-dark"
            @click="goPage('agreement/investor')">
            合格投资者承诺函
          </div>  -->
      </div>
    </van-popup>

    <!-- 到期后兑付方式 -->
    <van-popup class="automatic" v-model="automatic" closeable position="bottom" close-icon-position="top-left" @close="closePopupFundOutType">
      <div class="automatic-main ta-c p-10" style="height: 50vh">
        <div class="fs-16">到期后自动转存</div>
        <div class="automatic-control" @click="checkFundOutType">完成</div>
        <van-radio-group class="mt-10" v-model="tmpTundOutType">
          <van-cell class="menu no-border" v-for="(v, k) in fundOutTypeRadio" :key="'fundOutType-' + k">
            <van-radio slot="title" :name="k" checked-color="#c7a673">
              <div class="fs-16">{{ v }}</div>
            </van-radio>
          </van-cell>
        </van-radio-group>
      </div>
    </van-popup>

    <!-- 银行卡选择 -->
    <van-popup v-model="bankPicker.show" position="bottom">
      <van-picker show-toolbar value-key="tailTag" :columns="bankPicker.columns" :loading="bankPicker.loading" @cancel="bankPicker.show = false" @confirm="confirmBankPicker" />
    </van-popup>

    <!-- 余额不足弹框 -->
    <bl-eft :visible.sync="eftShow" :payType="payControl" title="余额不足,请充值"></bl-eft>

    <van-dialog v-model="showRateCouponUseRules" title="卡券使用规则">
      <div class="tips-dialog fs-14">
        <span>1、同类型卡券为可叠加时，可叠加多张使用；</span><br />
        <span>2、多张同类型卡券同时使用时,至多只能有一张不可叠加的券，其他的都需要是可叠加和任意叠加；</span><br />
        <span>3、不同类型多张卡券同时使用时,只能各用一张；</span><br />
        <span>4、具备任意叠加属性的券可以和任何情况下的任何券叠加；</span><br />
        <span>5、天安金交中心有最终解释权。</span><br />
      </div>
    </van-dialog>

    <van-dialog v-model="showCashCouponUseRules" title="卡券使用规则">
      <div class="tips-dialog fs-14">
        <span>1、同类型卡券为可叠加时，可叠加多张使用；</span><br />
        <span>2、多张同类型卡券同时使用时,至多只能有一张不可叠加的券，其他的都需要是可叠加和任意叠加；</span><br />
        <span>3、不同类型多张卡券同时使用时,只能各用一张；</span><br />
        <span>4、具备任意叠加属性的券可以和任何情况下的任何券叠加；</span><br />
        <span>5、天安金交中心有最终解释权。</span><br />
      </div>
    </van-dialog>

    <van-dialog v-model="showDecreCashCouponUseRules" title="卡券使用规则">
      <div class="tips-dialog fs-14">
        <span>1、同类型卡券为可叠加时，可叠加多张使用；</span><br />
        <span>2、多张同类型卡券同时使用时,至多只能有一张不可叠加的券，其他的都需要是可叠加和任意叠加；</span><br />
        <span>3、不同类型多张卡券同时使用时,只能各用一张；</span><br />
        <span>4、具备任意叠加属性的券可以和任何情况下的任何券叠加；</span><br />
        <span>5、天安金交中心有最终解释权。</span><br />
      </div>
    </van-dialog>
  </div>
</template>
  
  <script src="http://res.wx.qq.com/open/js/jweixin-1.6.0.js" />
  <script>
import session from "@/utils/session"
import * as CustApi from "@/api/cust"
import * as PayApi from "@/api/pay"
import * as SpecialPayApi from "@/api/special"
import * as ProductApi from "@/api/product"
import { mapGetters, mapMutations, mapActions } from "vuex"
import BlEft from "@/components/bl-eft"
import Popper from "vue-popperjs"
import "vue-popperjs/dist/vue-popper.css"

import {
  Tag,
  Row,
  Dialog,
  Col,
  Tabs,
  Tab,
  List,
  Switch,
  CellGroup,
  RadioGroup,
  Radio,
  Field,
  Icon,
  Popup,
  Picker,
  DropdownMenu,
  DropdownItem,
  Collapse,
  CollapseItem,
  Checkbox,
  CheckboxGroup
} from "vant"
import { returnAmount } from "../../api/pay"

export default {
  name: "Buying",
  components: {
    [Tag.name]: Tag,
    [Col.name]: Col,
    [Row.name]: Row,
    [Dialog.Component.name]: Dialog.Component,
    [Dialog.name]: Dialog,
    [Tabs.name]: Tabs,
    [Tab.name]: Tab,
    [List.name]: List,
    [Switch.name]: Switch,
    [Icon.name]: Icon,
    [CellGroup.name]: CellGroup,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [Field.name]: Field,
    [Checkbox.name]: Checkbox,
    [Popup.name]: Popup,
    [Picker.name]: Picker,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    [Collapse.name]: Collapse,
    [CollapseItem.name]: CollapseItem,
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup,
    BlEft,
    popper: Popper
  },

  data() {
    return {
      rateCouponActiveName: "available",
      cashCouponActiveName: "available",
      decreCashCouponActiveName: "available",
      showCashCouponPopup: false,
      showRateCouponPopup: false,
      showDecreCashCouponPopup: false,
      cashCouponTips: "",
      rateCouponTips: "",
      decreCashCouponTips: "",
      showCashCouponUseRules: false, //红包和使用规则
      showRateCouponUseRules: false, //加息券使用规则
      showDecreCashCouponUseRules: false, //满减券使用规则
      btnLoading: false,
      eftShow: false,
      showNextStep: true,
      other: "",
      bankCeiling: {
        show: false,
        loading: false,
        columns: []
      },
      orderId: null,
      bankPicker: {
        show: false,
        loading: false,
        columns: []
      },

      product: {
        miniAmount: "", // 最低买入金额
        currentRaise: "", // 当前已投
        raisedAmount: "", // 挂牌金额
        mustAmount: "" //  `挂牌金额` 减去 `当前已投` 小于 `最低买入金额`, 则必须投入这个金额
      },
      protocolList: {
        show: false,
        data: []
      },
      nextStepErrorTips: "", //不能进行下一步的错误提示
      balance: 0, //  可用余额
      tmpTundOutType: "2",
      fundOutTypeRadio: {},
      automatic: false, // 打开 `到期后自动转存` 的模态框
      bankQuota: true,
      chooseCard: "",
      payControl: {
        offlineAccount: "",
        offlineBank: "", //  线下转账开户行
        offlineName: "", //  线下转账账户名
        payType: "", //  支付方式1：线下；2：线上支付；3：余额支付；多个值逗号分隔
        withdrawType: "" //  提现方式2：到余额；3：到支付银行卡；多个值逗号分隔 4 到期自动转入体验金收益
      },
      payForm: {
        payAmount: 0, //支付金额 单位元
        tradeAmount: "", //交易金额 单位元
        cashCouponAmount: null, //体验金券面值之和，单位元
        rateCouponAmount: null, //加息券面值之和，单位百分比
        decreCashCouponAmount: null, //满减券面值之和，单位元
        productId: "", // 产品ID
        fundOutType: "4", // 1：到期自动购买同系列产品；2：到期自动转入余额；3：到期自动转入银行卡 4 到期自动转入体验金收益
        terminal: "H5", // 终端
        bindCardId: "", // 用户选择的银行卡的银行id
        pattern_buying: "3", //  支付方式 - 线下网银支付1/ 在线支付2/ 余额支付3,
        agreement_buying: false, // 同意服务协议及风险协议
        type: "",
        id: "", //订单ID，后端生成
        cashCouponIds: [], //带金券
        rateCouponIds: [], //加息券
        decreCashCouponIds: [], //满减券
        discount: 0, // 满减金额 单位分
        discountId: "" // 满减金额ID
      },
      cashCouponList: {
        loading: false,
        finished: false,
        data: [],
        available: [],
        inavailable: [],
        checked: []
      },
      rateCouponList: {
        loading: false,
        finished: false,
        data: [],
        available: [],
        inavailable: [],
        checked: []
      },
      decreCashCouponList: {
        loading: false,
        finished: false,
        data: [],
        available: [],
        inavailable: [],
        checked: []
      },
      returnAmount: 0 // 预期收益
    }
  },

  computed: {
    ...mapGetters(["userInfo", "channel"]),
    selfChannel() {
      //客户是否是天安或宝莲的客户
      let channel = this.$store.getters.channel
      return channel && ["bl", "ta", "tajk"].includes(channel.toLowerCase())
    },
    //体验金券可用的券转化为map，默认全部的券可用
    cashAvailableCouponMap() {
      let map = new Map()
      this.cashCouponList.data.forEach((item) => {
        map.set(item.id, item)
      })
      return map
    },
    //加息券可用的券转化为map，默认全部的券可用
    rateAvailableCouponMap() {
      let map = new Map()
      this.rateCouponList.data.forEach((item) => {
        map.set(item.id, item)
      })
      return map
    },
    //满减券可用的券转化为map，默认全部的券可用
    decreCashAvailableCouponMap() {
      let map = new Map()
      this.decreCashCouponList.data.forEach((item) => {
        map.set(item.id, item)
      })
      return map
    },
    condAmount() {
      return function (amount) {
        if (parseInt(amount) >= 10000) {
          return parseInt(amount) / 10000 + "万"
        } else {
          return parseInt(amount)
        }
      }
    },
    getMiniAmount() {
      return (miniAmount) => {
        let amo = this.numFormat(miniAmount, "0,0")
        return amo ? amo + "起" : ""
      }
    },
    returnScore() {
      if (this.payForm.tradeAmount) {
        return Math.round(
          (((this.payForm.tradeAmount * this.product.investDuration) / 365) *
            this.product.scoreRate) /
          100
        )
      }
      return ""
    },
    //计算最大可支付金额 = 可用余额 + 可用红包金额
    maxUsableBalance() {
      //判断是否有红包，如果有这不展示弹框
      let usableCouponAmount = this.cashCouponList.data
        .filter((coupon) => !coupon.disabled)
        .map((item) => item.amount)
        .reduce((a, b) => a + b, 0)
      // 满减券使用
      let decreCashCouponAmount = this.decreCashCouponList.data
        .filter((coupon) => !coupon.disabled)
        .map((item) => {
          let multiple = parseInt(this.payForm.tradeAmount / item.condStartAmt)
          multiple = multiple > 0 ? multiple : 1
          return item.amount * multiple
        })
        .reduce((a, b) => a + b, 0)
      usableCouponAmount += decreCashCouponAmount
      let maxUsableBalance = Number(this.balance) + usableCouponAmount * 100
      if (this.product.purchaseActivity) {
        // 如果有满减活动
        let multiple = parseInt(
          (this.payForm.tradeAmount * 100) /
          this.product.activityDiscount.amount
        )
        maxUsableBalance += this.product.activityDiscount.discount * multiple
      }
      //console.log("可用红包金额:" + usableCouponAmount + "元")
      //console.log("最大可支付金额:" + maxUsableBalance / 100 + "元")
      return maxUsableBalance
    }
  },

  watch: {
    product(newVal) {
      // `挂牌金额` 减去 `当前已投` 小于 `最低买入金额`
      let { raisedAmount, currentRaise, miniAmount } = newVal
      let mustAmount = 0

      if (raisedAmount - currentRaise < miniAmount) {
        mustAmount = (raisedAmount - currentRaise) / 100
        this.product.mustAmount = mustAmount
        this.payForm.tradeAmount = mustAmount
      }
    },

    "payControl.withdrawType": {
      handler(newVal) {
        let fundOutTypeRadio = {
          2: "到期自动转入余额",
          3: "到期自动转入银行卡",
          4: "到期自动转入体验金收益"
        }
        /*
        if (newVal) {
          newVal.split(",").forEach((item) => {
            this.fundOutTypeRadio[item] = fundOutTypeRadio[item]
          })
        }
        if (Object.keys(this.fundOutTypeRadio).length == 1) {
          this.tmpTundOutType = Object.keys(this.fundOutTypeRadio)[0]
          this.payForm.fundOutType = this.tmpTundOutType
        }*/
        this.fundOutTypeRadio = fundOutTypeRadio
        this.tmpTundOutType = 4
        this.payForm.fundOutType = this.tmpTundOutType
      },
      deep: true
    },

    "payForm.tradeAmount": {
      handler(val) {
        if (this.payForm.tradeAmount > 0) {
          this.payForm.tradeAmount = parseInt(val)
        }

        //1、uncheck 体验金券
        this.cashCouponList.checked = this.cashCouponList.checked.filter(
          (id) => {
            let packet = this.cashAvailableCouponMap.get(id)
            //判断红包是否可用
            return this.redpacketCouponAvailable(packet, val)
          }
        )
        this.payForm.cashCouponAmount = this.cashCouponList.checked
          .map((id) => {
            return this.cashAvailableCouponMap.get(id).amount
          })
          .reduce((p1, p2) => p1 + p2, 0)

        this.setPayAmount()

        //2、uncheck 加息券
        this.rateCouponList.checked = this.rateCouponList.checked.filter(
          (id) => {
            let packet = this.rateAvailableCouponMap.get(id)
            //判断红包是否可用
            return this.redpacketCouponAvailable(packet, val)
          }
        )
        this.payForm.rateCouponAmount = this.rateCouponList.checked
          .map((id) => {
            return this.rateAvailableCouponMap.get(id).amount
          })
          .reduce((p1, p2) => p1 + p2, 0)

        //2、uncheck 满减券
        this.decreCashCouponList.checked =
          this.decreCashCouponList.checked.filter((id) => {
            let packet = this.decreCashAvailableCouponMap.get(id)
            return this.redpacketCouponAvailable(packet, val)
          })
        // 满减券 美满多少减多少处理
        this.payForm.decreCashCouponAmount = this.decreCashCouponList.checked
          .map((id) => {
            let item = this.decreCashAvailableCouponMap.get(id)
            let multiple = parseInt(
              this.payForm.tradeAmount / item.condStartAmt
            )
            return item.amount * multiple
          })
          .reduce((p1, p2) => p1 + p2, 0)

        //3、根据交易金额过来可用的加息券
        this.rateCouponList.available = this.filterRateCoupon(true)
        if (this.rateCouponList.available.length > 0) {
          this.rateCouponTips = "本次可用券"
        } else {
          this.rateCouponTips = `有${this.rateCouponList.data.length}张券`
        }

        //4、根据交易金额过来可用的体验金券
        this.cashCouponList.available = this.filterCashCoupon(true)
        if (this.cashCouponList.available.length > 0) {
          this.cashCouponTips = "本次可用券"
        } else {
          this.cashCouponTips = `有${this.cashCouponList.data.length}张券`
        }

        //5、根据交易金额来提示可用的满减券
        this.decreCashCouponList.available = this.filterDecreCashCoupon(true)
        if (this.decreCashCouponList.available.length > 0) {
          this.decreCashCouponTips = "本次可用券"
        } else {
          this.decreCashCouponTips = `有${this.decreCashCouponList.data.length}张券`
        }
      },
      immediate: true,
      deep: true
    },

    //体验金券checked变化
    "cashCouponList.checked": {
      handler(checkedCashCoupon) {
        if (checkedCashCoupon.length >= 0) {
          this.payForm.cashCouponAmount = checkedCashCoupon
            .map((id) => {
              return this.cashAvailableCouponMap.get(id).amount
            })
            .reduce((p1, p2) => p1 + p2, 0)
          this.setPayAmount()
        }
        this.payForm.cashCouponIds = checkedCashCoupon
      },
      deep: true
    },

    //加息券checked变化
    "rateCouponList.checked": {
      handler(checkedRateCoupon) {
        if (checkedRateCoupon.length >= 0) {
          this.payForm.rateCouponAmount = checkedRateCoupon
            .map((id) => {
              return this.rateAvailableCouponMap.get(id).amount
            })
            .reduce((p1, p2) => this.accAdd(p1, p2), 0)
        }
        this.payForm.rateCouponIds = checkedRateCoupon
        this.loadReturnAmount()
      },
      deep: true
    },

    //满减券checked变化
    "decreCashCouponList.checked": {
      handler(checkedCashCoupon) {
        if (checkedCashCoupon.length >= 0) {
          this.payForm.decreCashCouponAmount = checkedCashCoupon
            .map((id) => {
              let item = this.decreCashAvailableCouponMap.get(id)
              let multiple = parseInt(
                this.payForm.tradeAmount / item.condStartAmt
              )
              return item.amount * multiple
            })
            .reduce((p1, p2) => p1 + p2, 0)
          this.setPayAmount()
        }
        this.payForm.decreCashCouponIds = checkedCashCoupon
      },
      deep: true
    },

    "payForm.payAmount": function (newPayAmount) {
      //判断余额支付的余额是否足够
      if (
        this.payForm.pattern_buying == "3" &&
        newPayAmount * 100 > this.balance
      ) {
        if (this.maxUsableBalance < this.payForm.tradeAmount * 100) {
          this.eftShow = true
          this.nextStepErrorTips = "余额不足,请充值"
        } else {
          this.nextStepErrorTips = "余额不足,请选择红包抵扣余额"
        }
        this.showNextStep = false
        return
      } else {
        this.eftShow = false
        this.showNextStep = true
      }
    }
  },

  beforeMount() {
    this.getUserInfo()
    this.productId = this.$route.query.productId
    this.payForm.productId = this.productId
    this.balance = this.userInfo.balance

    // 获得资产详情信息
    this.getDetail()
    // 获得银行卡列表以确认各大银行限额信息
    this.getBankList()
    this.getBindBankList()

    if (this.selfChannel) {
      this.loadCouponList()
    } else {
      this.readSession()
    }
  },

  created() {
    setTimeout(() => {
      wx.hideAllNonBaseMenuItem()
    }, 1000)
  },
  destroyed() {
    wx.showAllNonBaseMenuItem()
  },

  methods: {
    ...mapActions(["getUserInfo"]),
    //确认选择的加息券
    comfirmCheckedRateCoupon() {
      this.showRateCouponPopup = false
    },
    //确认选择的体验金券
    comfirmCheckedCashCoupon() {
      this.showCashCouponPopup = false
    },
    //确认选择的满减券
    comfirmCheckedDecreCashCoupon() {
      this.showDecreCashCouponPopup = false
    },
    //浮点型加法
    accAdd(arg1, arg2) {
      let r1, r2, m
      try {
        r1 = arg1.toString().split(".")[1].length
      } catch (e) {
        r1 = 0
      }
      try {
        r2 = arg2.toString().split(".")[1].length
      } catch (e) {
        r2 = 0
      }
      m = Math.pow(10, Math.max(r1, r2))
      return (arg1 * m + arg2 * m) / m
    },
    /// 选择加息券
    checkedRateCouponChanged(checkedValueArray) {
      //如果用户选择了一个不可叠加的红包，则其余不可叠加的红包都要disabled
      let checkedSuperpositionRedpacketId = checkedValueArray.find(
        (checkedRedpacketId) => {
          let checkedPacket =
            this.rateAvailableCouponMap.get(checkedRedpacketId)
          return checkedPacket.ifSuperposition == "0"
        }
      )
      let filterNoRate = this.onFilterAnyRedpacket(1)
      if (checkedSuperpositionRedpacketId) {
        //一旦选择的红包中有是不可叠加的，那么禁用所有不可叠加的红包
        //不可叠加的红包只选择一个
        this.rateCouponList.available = this.rateCouponList.available.map(
          (coupon) => {
            if (
              coupon.id != checkedSuperpositionRedpacketId &&
              coupon.ifSuperposition == "0"
            ) {
              coupon.disabled = true
              return coupon
            }
            return coupon
          }
        )
      } else {
        //如果没有不可叠加的红包，那把之前禁用的红包启用
        this.rateCouponList.available = this.rateCouponList.available.map(
          (coupon) => {
            if (coupon.disabled) {
              coupon.disabled = false
              return coupon
            }
            return coupon
          }
        )
      }
      //如果已经选择了一张体验金券，那么加息券只能选择一张
      //除了选择的这一张之外都要被禁用
      let filterRateCount = this.onFilterAnyRedpacket(
        1,
        this.rateCouponList.checked
      )
      if (
        filterNoRate.checkCashCount == 1 ||
        filterNoRate.checkDecreCashCount == 1
      ) {
        this.rateCouponList.available = this.rateCouponList.available.map(
          (coupon) => {
            if (checkedValueArray.find((id) => id == coupon.id)) {
              coupon.disabled = false
            } else {
              //如果一个都没选择所有的红包都是可用
              //如果选择的有加息券，那就把除了选择的加息券之外的都禁用
              coupon.disabled =
                coupon.ifSuperposition == 2 ? false : filterRateCount > 0
            }
            return coupon
          }
        )
      } else {
        this.rateCouponList.available = this.rateCouponList.available.map(
          (coupon) => {
            if (
              coupon.ifSuperposition != 2 &&
              coupon.id != checkedSuperpositionRedpacketId &&
              (filterNoRate.checkCashCount > 1 ||
                filterNoRate.checkDecreCashCount > 1)
            ) {
              coupon.disabled = true
            }
            return coupon
          }
        )
      }
    },
    /// 选择体验金券
    checkedCashCouponChanged(checkedValueArray) {
      //如果用户选择了一个不可叠加的红包，则其余不可叠加的红包都要disabled
      let checkedSuperpositionRedpacketId = checkedValueArray.find(
        (checkedRedpacketId) => {
          let checkedPacket =
            this.cashAvailableCouponMap.get(checkedRedpacketId)
          return checkedPacket.ifSuperposition == "0"
        }
      )
      let filterNoCash = this.onFilterAnyRedpacket(2)
      if (checkedSuperpositionRedpacketId) {
        //一旦选择的红包中有是不可叠加的，那么禁用所有不可叠加的红包
        //不可叠加的红包只选择一个
        this.cashCouponList.available = this.cashCouponList.available.map(
          (coupon) => {
            if (
              coupon.id != checkedSuperpositionRedpacketId &&
              coupon.ifSuperposition == "0"
            ) {
              coupon.disabled = true
              return coupon
            }
            return coupon
          }
        )
      } else {
        //如果没有不可叠加的红包，那把之前禁用的红包启用
        this.cashCouponList.available = this.cashCouponList.available.map(
          (coupon) => {
            if (coupon.disabled) {
              coupon.disabled = false
              return coupon
            }
            return coupon
          }
        )
      }
      //如果已经选择了一张加息券，那么体验金券只能选择一张
      //除了选择的这一张之外都要被禁用
      let filterCashCount = this.onFilterAnyRedpacket(
        2,
        this.cashCouponList.checked
      )
      if (
        filterNoCash.checkRateCount == 1 ||
        filterNoCash.checkDecreCashCount == 1
      ) {
        this.cashCouponList.available = this.cashCouponList.available.map(
          (coupon) => {
            if (checkedValueArray.find((id) => id == coupon.id)) {
              coupon.disabled = false
            } else {
              //如果一个都没选择所有的红包都是可用
              //如果选择的有加息券，那就把除了选择的加息券之外的都禁用
              coupon.disabled =
                coupon.ifSuperposition == 2 ? false : filterCashCount > 0
            }
            return coupon
          }
        )
      } else {
        this.cashCouponList.available = this.cashCouponList.available.map(
          (coupon) => {
            if (
              coupon.ifSuperposition != 2 &&
              coupon.id != checkedSuperpositionRedpacketId &&
              (filterNoCash.checkRateCount > 1 ||
                filterNoCash.checkDecreCashCount > 1)
            ) {
              coupon.disabled = true
            }
            return coupon
          }
        )
      }
    },
    /// 选择满减券
    checkedDecreCashCouponChanged(checkedValueArray) {
      //如果用户选择了一个不可叠加的红包，则其余不可叠加的红包都要disabled
      let checkedSuperpositionRedpacketId = checkedValueArray.find(
        (checkedRedpacketId) => {
          let checkedPacket =
            this.decreCashAvailableCouponMap.get(checkedRedpacketId)
          return checkedPacket.ifSuperposition == "0"
        }
      )
      let filterNoDecreCash = this.onFilterAnyRedpacket(3)
      if (checkedSuperpositionRedpacketId) {
        //一旦选择的红包中有是不可叠加的，那么禁用所有不可叠加的红包
        //不可叠加的红包只选择一个
        this.decreCashCouponList.available =
          this.decreCashCouponList.available.map((coupon) => {
            if (
              coupon.id != checkedSuperpositionRedpacketId &&
              coupon.ifSuperposition == "0"
            ) {
              coupon.disabled = true
              return coupon
            }
            return coupon
          })
      } else {
        //如果没有不可叠加的红包，那把之前禁用的红包启用
        this.decreCashCouponList.available =
          this.decreCashCouponList.available.map((coupon) => {
            if (coupon.disabled) {
              coupon.disabled = false
              return coupon
            }
            return coupon
          })
      }
      //如果已经选择了一张加息券，那么体验金券只能选择一张
      //除了选择的这一张之外都要被禁用
      let filterCashCount = this.onFilterAnyRedpacket(
        3,
        this.decreCashCouponList.checked
      )
      if (
        filterNoDecreCash.checkRateCount == 1 ||
        filterNoDecreCash.checkCashCount == 1
      ) {
        this.decreCashCouponList.available =
          this.decreCashCouponList.available.map((coupon) => {
            if (checkedValueArray.find((id) => id == coupon.id)) {
              coupon.disabled = false
            } else {
              //如果一个都没选择所有的红包都是可用
              //如果选择的有加息券，那就把除了选择的加息券之外的都禁用
              coupon.disabled =
                coupon.ifSuperposition == 2 ? false : filterCashCount > 0
            }
            return coupon
          })
      } else {
        this.decreCashCouponList.available =
          this.decreCashCouponList.available.map((coupon) => {
            if (
              coupon.ifSuperposition != 2 &&
              coupon.id != checkedSuperpositionRedpacketId &&
              (filterNoDecreCash.checkRateCount > 1 ||
                filterNoDecreCash.checkCashCount > 1)
            ) {
              coupon.disabled = true
            }
            return coupon
          })
      }
    },

    /// 打开加息券
    openRateCouponPopup() {
      // 去掉不同类型卡券同时使用,只能各选一张非任意叠加券
      let filterNoRate = this.onFilterAnyRedpacket(1)
      if (
        filterNoRate.checkCashCount > 1 ||
        filterNoRate.checkDecreCashCount > 1
      ) {
        this._showToast("不同类型卡券同时使用,只能各选一张非任意叠加券")
      }
      this.checkedRateCouponChanged(this.rateCouponList.checked)
      //过滤不可用数据
      this.rateCouponList.inavailable = this.filterRateCoupon(false)
    },

    /// 打开体验金券
    openCashCouponPopup() {
      // 去掉不同类型卡券同时使用,只能各选一张非任意叠加券
      let filterNoCash = this.onFilterAnyRedpacket(2)
      if (
        filterNoCash.checkRateCount > 1 ||
        filterNoCash.checkDecreCashCount > 1
      ) {
        this._showToast("不同类型卡券同时使用,只能各选一张非任意叠加券")
      }
      this.checkedCashCouponChanged(this.cashCouponList.checked)
      //过滤不可用数据
      this.cashCouponList.inavailable = this.filterCashCoupon(false)
    },

    /// 打开满减券
    openDecreCashCouponPopup() {
      // 去掉体验金券、加息券、满减券同时使用,只能各选一张
      let filterNoDecreCash = this.onFilterAnyRedpacket(3)
      if (
        filterNoDecreCash.checkRateCount > 1 ||
        filterNoDecreCash.checkCashCount > 1
      ) {
        this._showToast("不同类型卡券同时使用,只能各选一张非任意叠加券")
      }
      this.checkedDecreCashCouponChanged(this.decreCashCouponList.checked)
      //过滤不可用数据
      this.decreCashCouponList.inavailable = this.filterDecreCashCoupon(false)
    },

    /**
     * 过滤已选择体验金券、加息券、满减券任意叠加外的其他券数量
     * couponType 卡券类型 1 加息券 2 体验金券 3 满减券 4 体验券
     * array 当前需要过滤任意叠加券的集合
     * return 已选择除任意叠加券其他数量
     */
    onFilterAnyRedpacket(couponType, array) {
      if (array) {
        let count = 0
        array.forEach((couponId) => {
          let checkedCoupon =
            couponType == 1
              ? this.rateAvailableCouponMap.get(couponId)
              : couponType == 2
                ? this.cashAvailableCouponMap.get(couponId)
                : this.decreCashAvailableCouponMap.get(couponId)
          if (checkedCoupon.ifSuperposition !== 2) {
            count++
          }
        })
        return count
      }
      let params = {
        checkRateCount: 0,
        checkCashCount: 0,
        checkDecreCashCount: 0
      }
      if (couponType == 1) {
        this.cashCouponList.checked.forEach((couponId) => {
          let checkedCoupon = this.cashAvailableCouponMap.get(couponId)
          if (checkedCoupon.ifSuperposition !== 2) {
            params.checkCashCount++
          }
        })
        this.decreCashCouponList.checked.forEach((couponId) => {
          let checkedCoupon = this.decreCashAvailableCouponMap.get(couponId)
          if (checkedCoupon.ifSuperposition !== 2) {
            params.checkDecreCashCount++
          }
        })
      } else if (couponType == 2) {
        this.rateCouponList.checked.forEach((couponId) => {
          let checkedCoupon = this.rateAvailableCouponMap.get(couponId)
          if (checkedCoupon.ifSuperposition !== 2) {
            params.checkRateCount++
          }
        })
        this.decreCashCouponList.checked.forEach((couponId) => {
          let checkedCoupon = this.decreCashAvailableCouponMap.get(couponId)
          if (checkedCoupon.ifSuperposition !== 2) {
            params.checkDecreCashCount++
          }
        })
      } else if (couponType == 3) {
        this.cashCouponList.checked.forEach((couponId) => {
          let checkedCoupon = this.cashAvailableCouponMap.get(couponId)
          if (checkedCoupon.ifSuperposition !== 2) {
            params.checkCashCount++
          }
        })
        this.rateCouponList.checked.forEach((couponId) => {
          let checkedCoupon = this.rateAvailableCouponMap.get(couponId)
          if (checkedCoupon.ifSuperposition !== 2) {
            params.checkRateCount++
          }
        })
      }
      return params
    },

    onClickCashCouponCell() {
      this.showCashCouponPopup = this.cashCouponList.data.length > 0
    },

    onClickRateCouponCell() {
      this.showRateCouponPopup = this.rateCouponList.data.length > 0
    },

    onClickDecreCashCouponCell() {
      this.showDecreCashCouponPopup = this.decreCashCouponList.data.length > 0
    },

    /**
     * 判断红包类的卡券(加息、代金、满减券)不是可用
     */
    redpacketCouponAvailable(item, tradeAmount) {
      let tradeAmountNumber = Number(
        tradeAmount || this.payForm.tradeAmount || 0
      )
      // 0 未使用
      return (
        item.status == "0" &&
        Number(item.condStartAmt || 0) <= tradeAmountNumber
      )
    },

    /**
     * 判断红包类的卡券(加息、代金、满减券)不是不可用
     */
    redpacketCouponInavailable(item) {
      //1 已使用 2 已过期
      return (
        item.status == "2" ||
        item.status == "1" ||
        Number(item.condStartAmt || 0) > Number(this.payForm.tradeAmount || 0)
      )
    },

    /// 过滤加息券是否可用
    filterCashCoupon(available) {
      return this.cashCouponList.data.filter((item) => {
        if (available == true) {
          return this.redpacketCouponAvailable(item)
        } else {
          return this.redpacketCouponInavailable(item)
        }
      })
    },

    /// 过滤体验金券是否可用
    filterRateCoupon(available) {
      return this.rateCouponList.data.filter((item) => {
        if (available == true) {
          return this.redpacketCouponAvailable(item)
        } else {
          return this.redpacketCouponInavailable(item)
        }
      })
    },

    /// 过滤满减券是否可用
    filterDecreCashCoupon(available) {
      return this.decreCashCouponList.data.filter((item) => {
        if (available == true) {
          return this.redpacketCouponAvailable(item)
        } else {
          return this.redpacketCouponInavailable(item)
        }
      })
    },

    //分割日期时间
    dateSplit(val) {
      return val.split(" ")[0]
    },
    patternBuyingChange(patternBuying) {
      if (patternBuying == "3" && this.payForm.payAmount * 100 > this.balance) {
        if (this.maxUsableBalance < this.payForm.tradeAmount * 100) {
          this.eftShow = true
          this.nextStepErrorTips = "余额不足,请充值"
        } else {
          this.nextStepErrorTips = "余额不足,请选择红包抵扣余额"
        }
        this.showNextStep = false
        return
      } else {
        this.eftShow = false
        this.showNextStep = true
      }
    },
    readSession() {
      let payForm = session.getJson("payForm")
      if (payForm && payForm.productId === this.$route.query.productId) {
        this.cashCouponList.checked = payForm.cashCouponIds
        this.rateCouponList.checked = payForm.rateCouponIds
        this.payForm = payForm
      } else {
        session.del("payForm")
      }
    },
    getDetail() {
      ProductApi.detail(this.productId)
        .then((data) => {
          this.product = data
          this.getProtocolList()
          this.getPayType()
          this.setPayAmount()
        })
        .catch((e) => {
          this.$toast(e.msg || e.message)
        })
    },

    getBankList() {
      this.bankPicker.loading = true
      return PayApi.banklist()
        .then((data) => {
          this.bankCeiling.columns = data
          this.bankPicker.loading = false
        })
        .catch((e) => {
          this.$toast(e.msg || e.message)
        })
    },

    getPayType() {
      PayApi.paytype({ chanlCode: this.product.chanlCode })
        .then((data) => {
          this.setPayType(data)
          this.payControl = Object.assign({}, this.payControl, data)
        })
        .catch((e) => {
          this.$toast(e.msg || e.message)
        })
    },
    onInput(value) {
      if (value == 0) {
        this.payForm.tradeAmount = ""
      }
    },

    // 失去焦点，如果金额小于最小起购金额。自动填充最小起购金额
    setAmountInMin() {
      let miniAmount = this.product.miniAmount / 100
      if (!this.product.mustAmount) {
        if (this.payForm.tradeAmount < miniAmount && !this.product.mustAmount) {
          this.$toast(`买入金额 ${miniAmount} 元起`)
          this.payForm.tradeAmount = miniAmount
        }
        if (
          miniAmount >= this.product.stepMoney / 100 &&
          (this.payForm.tradeAmount / (this.product.stepMoney / 100))
            .toString()
            .indexOf(".") >= 0
        ) {
          this.$toast(`买入金额必须为${this.product.stepMoney / 100}的整数倍`)
          this.payForm.tradeAmount =
            (Math.ceil(
              this.payForm.tradeAmount / (this.product.stepMoney / 100)
            ) *
              this.product.stepMoney) /
            100
        }
      }
    },

    // 计算实付金额
    setPayAmount() {
      this.payForm.discount = 0
      this.payForm.discountId = ""

      let buyAmount = 0
      this.cashCouponList.checked.find((checkedRedpacketId) => {
        let checkedPacket = this.cashAvailableCouponMap.get(checkedRedpacketId)
        buyAmount += checkedPacket.amount
        return checkedPacket.ifSuperposition == "0"
      })
      this.payForm.tradeAmount = buyAmount

      if (this.product.purchaseActivity) {
        // 如果有满减活动
        if (
          this.payForm.tradeAmount * 100 >=
          this.product.activityDiscount.amount
        ) {
          let multiple = parseInt(
            (this.payForm.tradeAmount * 100) /
            this.product.activityDiscount.amount
          )
          this.payForm.discount =
            this.product.activityDiscount.discount * multiple
          this.payForm.discountId = this.product.activityDiscount.id
          this.payForm.payAmount =
            this.payForm.tradeAmount -
            this.payForm.cashCouponAmount -
            this.payForm.discount / 100 -
            this.payForm.decreCashCouponAmount
        } else {
          this.payForm.payAmount =
            this.payForm.tradeAmount -
            this.payForm.cashCouponAmount -
            this.payForm.decreCashCouponAmount
        }
      } else {
        this.payForm.payAmount =
          this.payForm.tradeAmount -
          this.payForm.cashCouponAmount -
          this.payForm.decreCashCouponAmount
      }
    },

    goPage(path) {
      session.setJson("payForm", this.payForm)
      this.$router.push(path)
      this.protocolList.show = false
    },

    // 确认银行卡的开户行
    confirmBankPicker(value) {
      this.bankPicker.show = false
      this.payForm.bindCardId = value.id
      this.chooseCard = value.tailTag
    },

    onClickNext() {
      let fail_message = ""
      if (Number(this.payForm.tradeAmount) === 0) {
        this.$toast("请输入买入金额")
        return
      }

      if (
        this.payForm.tradeAmount < this.product.miniAmount / 100 &&
        !this.product.mustAmount
      ) {
        fail_message =
          "最低买入金额" + this.numFormat(this.product.miniAmount) + "元"
        this.$toast(fail_message)
        return
      }
      session.setJson("payForm", this.payForm)
      if (
        this.payForm.pattern_buying == 3 &&
        Number(this.payForm.payAmount || 0) > Number(this.balance || 0) / 100
      ) {
        if (this.payControl && !this.payControl.onlinePay) {
          //如果在线支付功能没有开启，就跳转到离线充值页面
          this.$toast({
            message: "余额不足,请充值",
            onClose: () => {
              this.$router.push({
                name: "recharge_offline",
                query: { redirect: this.$route.fullPath }
              })
            }
          })
        } else {
          //佛者跳转到在线充值页面,如果在线充值页面再提示超限制，再跳转到离线充值
          this.$toast({
            message: "余额不足,请充值",
            onClose: () => {
              if (this.userInfo.isBindCard) {
                // this.$router.push({ name: "recharge_1" })
                this.$router.push({
                  name: "recharge_offline",
                  query: { redirect: this.$route.fullPath }
                })
              } else if (this.userInfo.isAuthName) {
                this.$router.push({ name: "recharge_2" })
              } else {
                this.$router.push({ name: "recharge_3" })
              }
            }
          })
        }
        return
      }

      if (!this.payForm.agreement_buying) {
        this.$toast("请同意体验")
        return
      }
      this._showLoading()
      ProductApi.canbuy(this.productId, parseInt(this.payForm.tradeAmount))
        .then((data) => {
          if (data.canBuy) {
            if (this.userInfo.isBindCard) {
              if (this.payControl.showConfirm) {
                this._dismissLoading()
                this.$router.push({
                  name: "orderconfirm"
                })
              } else {
                switch (this.payForm.pattern_buying) {
                  case "2": // '在线支付',
                    this.fetchOrderIdRequest("online")
                    break
                  case "3": // '余额支付',
                    this.fetchOrderIdRequest("offline")
                    break
                }
              }
            } else {
              session.setJson("payForm", this.payForm)
              this._dismissLoading()
              this.$router.push({
                path: "/bindcard",
                query: { redirect: "buying" }
              })
            }
          } else {
            this._dismissLoading()
            this.$toast(data.msg || "不符合购买条件")
          }
        })
        .catch((e) => {
          this._dismissLoading()
          this.$toast(e.msg || e.message)
        })
    },
    // 创建订单，获取订单号
    fetchOrderIdRequest(type) {
      this.payForm.type = type
      this.payForm.id = ""
      PayApi.getOrderId(this.payForm)
        .then((data) => {
          this.orderId = data
          this.payForm.id = data
          localStorage.removeItem("payForm")
          localStorage.setItem("payForm", JSON.stringify(this.payForm))
          session.setJson("payForm", this.payForm)
          // this.getSignaturePDF()
          this._dismissLoading()
          this.$router.push({
            name: "orderconfirm"
          })
        })
        .catch((e) => {
          this._dismissLoading()
          if (e.code == 2006) {
            //余额支付本身不会有这个错误码，所以只有在线支付，这里直接跳转到离线转账页面即可
            this.$toast({
              message: "支付金额超过银行支付限额,请使用线下转账充值后再认购",
              onClose: () => {
                this.$router.push({
                  name: "recharge_offline",
                  query: { redirect: this.$route.fullPath }
                })
              }
            })
            return
          } else if (e.code == 2010) {
            // 已存在未支付订单
            Dialog.alert({
              title: "温馨提示",
              message: e.msg || e.message,
              showCancelButton: true,
              confirmButtonText: "去支付",
              cancelButtonText: "取消订单",
              theme: "round-button"
            })
              .then(() => {
                this.onPay(e.data)
              })
              .catch(() => {
                PayApi.cancelOrder()
                  .then((data) => {
                    if (data) {
                      this.$toast(data)
                    }
                  })
                  .catch((e) => {
                    this.$toast(e.msg || e.message)
                  })
              })
          } else if (e.code == 5000) {
            //购买红包抵扣不合规
            this.getUserInfo()
            this.productId = this.$route.query.productId
            this.payForm.productId = this.productId
            this.balance = this.userInfo.balance

            this.payForm.cashCouponAmount = 0
            this.payForm.cashCouponIds = []
            this.payForm.rateCouponAmount = 0
            this.payForm.rateCouponIds = []
            this.payForm.decreCashCouponIds = []
            this.payForm.decreCashCouponAmount = 0
            session.setJson("payForm", this.payForm)

            // 获得资产详情信息
            this.getDetail()
            // 获得银行卡列表以确认各大银行限额信息
            this.getBankList()
            this.getBindBankList()

            if (this.selfChannel) {
              this.loadCouponList()
            } else {
              this.readSession()
            }
            this.$toast(e.msg || e.message)
          } else {
            this.$toast(e.msg || e.message)
          }
        })
    },
    onPay(item) {
      //item.payType 1 余额 2 在线（银行卡支付） 3 线下
      this._showLoading()
      this.payForm.payAmount = item.payAmount / 100
      this.payForm.tradeAmount = item.tradeAmount / 100
      this.payForm.cashCouponAmount = item.cashCouponAmount / 100
      this.payForm.rateCouponAmount = item.rateCouponAmount
      this.payForm.productId = item.productId
      this.payForm.fundOutType = item.fundOutType
      this.payForm.bindCardId = item.bindCardId
      this.payForm.pattern_buying =
        item.payType == 1 ? "3" : item.payType == 2 ? "2" : ""
      this.payForm.agreement_buying = true
      this.payForm.type =
        item.payType == 1 ? "offline" : item.payType == 2 ? "online" : ""
      this.orderId = item.id
      this.payForm.id = item.id
      this.payForm.cashCouponIds = []
      this.payForm.rateCouponIds = []
      this.payForm.discount = item.discount
      this.payForm.discountId = ""

      localStorage.removeItem("payForm")
      localStorage.setItem("payForm", JSON.stringify(this.payForm))
      session.setJson("payForm", this.payForm)
      /*
      if (item.signStatus == 1) {
        if (item.productType == 1) {
          // 产品类型 1-债券类型 2-拍卖类型
          //未签署
          this.getSignaturePDF()
        } else {
          //未签署
          // this.getAuctionSignaturePDF(item.id)
        }
      } else if (item.signStatus == 2) {
        //签署完成
        this._dismissLoading()
        this.$router.push({
          name: "orderconfirm",
          params: { countDownTime: item.countDownTime }
        })
      }*/
      this._dismissLoading()
      this.$router.push({
        name: "orderconfirm",
        params: { countDownTime: item.countDownTime }
      })
    },
    // 获取e签宝
    getSignaturePDF() {
      this.payForm.id = this.orderId
      if (this.product.isProductBaseAccount !== 0) {
        // 0：普通产品 1：特殊产品1 2：特殊产品2 是否限定为针对产品账户设置的产品，除了产品账户之外的余额无法购买
        SpecialPayApi.specialProtocolSign(this.payForm)
          .then((data) => {
            this._dismissLoading()
            location.href = data
          })
          .catch((e) => {
            this._dismissLoading()
            this.$toast(e.msg || e.message)
          })
      } else {
        PayApi.getSignatureUrl({ id: this.payForm.id })
          .then((data) => {
            this._dismissLoading()
            location.href = data
          })
          .catch((e) => {
            this._dismissLoading()
            this.$toast(e.msg || e.message)
          })
      }
    },

    getProtocolList() {
      ProductApi.listtradeprotocol(this.product.typeId)
        .then((data) => {
          this.protocolList.data = data
        })
        .catch((e) => {
          this.$toast(e.msg || e.message)
        })
    },

    onShowQuota() {
      this.bankPicker.show = true
    },
    showProtocol(id) {
      if (
        !this.product.mustAmount &&
        this.payForm.tradeAmount < this.product.miniAmount / 100
      ) {
        this.$toast("请输正确金额！")
        return
      }
      session.setJson("payForm", this.payForm)
      let attachRate = ""
      if (this.product.activityDiscount && this.product.activityDiscount.rate) {
        //获取活动加息率
        attachRate = this.product.activityDiscount.rate
      }
      this.$router.push({
        path: "/agreement",
        query: {
          productId: this.productId,
          id: id,
          tradeAmount: this.payForm.tradeAmount,
          attachRate: attachRate,
          rateCouponIds: this.payForm.rateCouponIds
        }
      })
      this.protocolList.show = false
    },
    checkFundOutType() {
      this.payForm.fundOutType = this.tmpTundOutType
      this.automatic = false
    },
    closePopupFundOutType() {
      this.tmpTundOutType = this.payForm.fundOutType
      this.automatic = false
    },
    getBindBankList() {
      this.bankPicker.loading = true
      CustApi.listBindCard()
        .then((data) => {
          this.bankPicker.columns = data || []
          this.bankPicker.loading = false
          if (data && data.length) {
            this.payForm.bindCardId = data[0].id
            this.chooseCard = data[0].tailTag
          }
        })
        .catch((e) => {
          this.$toast(e.msg || e.message)
        })
    },
    loadCouponList() {
      PayApi.getReadRedBagList({ productId: this.productId, status: 0 })
        .then((couponList) => {
          //分出来体验金券和加息券
          if (couponList) {
            this.rateCouponList.data = couponList.filter(
              (item) => item.type == "1"
            )
            let rateCouponLength = this.rateCouponList.data.length
            this.rateCouponTips =
              rateCouponLength > 0 ? `有${rateCouponLength}张券` : "无"
            this.rateCouponList.loading = false
            this.rateCouponList.finished = true

            // item.type == "2"
            this.cashCouponList.data = couponList.filter(
              (item) => item.type == "4"
            )
            let cashCouponLength = this.cashCouponList.data.length
            this.cashCouponTips =
              cashCouponLength > 0 ? `有${cashCouponLength}张券` : "无"
            this.cashCouponList.loading = false
            this.cashCouponList.finished = true

            this.decreCashCouponList.data = couponList.filter(
              (item) => item.type == "3"
            )
            let decreCashCouponLength = this.decreCashCouponList.data.length
            this.decreCashCouponTips =
              decreCashCouponLength > 0
                ? `有${decreCashCouponLength}张券`
                : "无"
            this.decreCashCouponList.loading = false
            this.decreCashCouponList.finished = true

            this.payForm.tradeAmount = "0"
            let buyAmount = 0
            let isExist = false
            // 默认选中体验金券并设置买入金额
            this.cashCouponList.data.forEach((item) => {
              // ifSuperposition 是否叠加使用 : 0-不可叠加 1-可叠加 2-任意叠加
              if (item.ifSuperposition == 0 || item.ifSuperposition == 1) {
                if (!isExist) {
                  this.cashCouponList.checked.push(item.id)
                  buyAmount += item.amount
                  isExist = true
                }
              } else {
                this.cashCouponList.checked.push(item.id)
                buyAmount += item.amount
              }
            })
            this.payForm.tradeAmount = buyAmount
          } else {
            this.rateCouponTips = "无"
            this.cashCouponTips = "无"
            this.decreCashCouponTips = "无"
          }
          this.readSession()
        })
        .catch((err) => {
          console.log(err)
          this.rateCouponList.loading = false
          this.rateCouponList.finished = true
          this.cashCouponList.loading = false
          this.cashCouponList.finished = true
          this.decreCashCouponList.loading = false
          this.decreCashCouponList.finished = true
          this.$toast(err.msg)
        })
    },
    ...mapMutations(["setPayType"]),

    // 获取预期收益
    loadReturnAmount() {
      returnAmount({
        productId: this.product.id,
        tradeAmount: this.payForm.tradeAmount || 0,
        rateCouponAmount: this.payForm.rateCouponAmount || 0
      }, this.product.productType)
        .then((data) => {
          this.returnAmount = data
        })
        .catch((e) => {
          console.log("error info == %O", e.msg)
        })
    }
  }
}
</script>
  
  <style scoped lang="less">
@tips-color: #c7a673;

.tips-dialog {
  padding: 10px;
  letter-spacing: 2px;
  line-height: 0.7rem;
}
.coupon_border {
  height: 100%;
  border-right: 1px dashed gray;
}

.protcol_agree_box {
  border-bottom: #f1f5f8 dashed 1px;
}

.activity_box {
  .fs-14 {
    padding: 8px 5px;
    background-color: red;
    border-radius: 30px;
    color: white;
  }
}

.activi .page-container {
  overflow: hidden;
  padding-bottom: 110px;
}

.tips-color {
  color: @tips-color;
}

.tips-amount-color {
  // color: red;
}

// 没法使用 scoped , 否则会导致样式无法选中
.buying {
  overflow-y: scroll;
  padding-bottom: 120px;

  ::v-deep .tian-amount {
    .van-field__left-icon {
      font-weight: 600;
    }

    .van-field__left-icon,
    .van-field__control {
      font-size: 32px;
      line-height: 36px;
    }
  }

  .coupon .van-cell {
    padding: 0px;
  }
}

.page-action {
  .van-cell {
    padding: 10px 0px;
  }
}

.cash-coupon-list {
  overflow: hidden;
  // 漏出底部的确定按钮，避免遮住滑动条
  padding-bottom: 90px;

  .cash-coupon-panel {
    width: 100%;
    height: 12rem;
    overflow-y: auto;
    background-color: #f1f5f8d0;

    .coupon-cell-container {
      position: relative;
      border: 1px solid #fff;
      border-radius: 5px;
      box-shadow: 0 3px 3px #bdbdbd;
      border-top: 5px solid rgb(252, 101, 36);
      margin: 15px;

      .coupon_checkbox {
        position: absolute;
        right: 15px; //负值为自身体积的一半
        top: 1rem;
        z-index: 800;
        display: flex;
        justify-content: center;
        background-color: white;
        border-radius: 9px;
      }
    }

    .coupon_item_container {
      position: relative;

      .coupon_item_left {
        text-align: center;
        display: flex;
        flex-direction: column;
        justify-content: center;
        color: white;
        height: 100%;
        background: url("../../assets/img/coupon/coupon.png");
        background-position: center;
        background-repeat: no-repeat;
        background-size: 100% 100%;

        span {
          font-size: 20px;
        }
      }

      .coupon_item_right {
        margin-left: 15px;

        .if-any-superposition {
          font-size: 10px;
          border-radius: 20px;
          padding: 3px 10px;
          color: white;
          background-color: #ff9900;
        }
        .if-superposition {
          font-size: 10px;
          border-radius: 20px;
          padding: 3px 10px;
          color: white;
          background-color: rgb(252, 101, 36);
        }

        .if-no-superposition {
          font-size: 10px;
          border-radius: 10px;
          padding: 3px 5px;
          background-color: #e7eaed;
        }
        .label-bg {
          margin-top: 5px;
          .if_label {
            font-size: 10px;
            padding: 3px 5px;
            border-radius: 10px;
            color: white;
            background-color: rgb(228, 152, 20);
          }
        }
      }
    }
  }

  .fixed-popup-bottom {
    position: fixed;
    display: flex;
    flex-direction: column;
    justify-content: center;
    bottom: 0;
    width: 100%;
    height: 90px;
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: white;

    button {
      width: 80%;
      padding: 20px;
      border-radius: 25px;
    }
  }
}
.page-action {
  height: auto;

  ::v-deep .van-checkbox {
    padding: 10px 20px;
    // background: @gray-dark;
    background: white;
    font-size: 16px;

    .van-checkbox__label {
      color: #666666;
    }

    .van-checkbox__icon {
      position: relative;
      top: 1px;

      .van-icon {
        border-width: 1px;
      }
    }
  }
  .next_step {
    background-color: red;
    border-radius: 30px;
    color: white;
    word-break: break-all;
    word-wrap: break-word;
  }

  .page_action_left {
    height: 50px;
    display: flex;
    flex-direction: column;
    padding-top: 10px;
    align-items: flex-start;
    justify-content: center;
  }

  .page_action_right {
    height: 50px;
    padding-top: 10px;
  }
}

.automatic-control {
  position: absolute;
  right: 20px;
  top: 12px;
  border: 1px solid #c1a76a;
  padding: 0 6px;
  color: #c1a76a;
}

.tian-amount {
  ::v-deep .van-field__control:disabled {
    color: inherit;
    -webkit-text-fill-color: inherit;
  }
}

.buying-title {
  text-align: center;
  font-size: 20px;
  color: #575e66;
  position: relative;
}

.limit-list {
  padding-top: 10px;
  max-height: 80%;
  .van-cell {
    padding: 0rem 0.2rem;
  }

  .van-cell__value {
    font-size: 12px;
    flex: 3;
  }

  .van-cell__title {
    flex: 1;
  }
}

.bank-card-selector {
  .van-field {
    font-size: 0.36rem;
  }
}
</style>
  